import React from "react";
import PropTypes from "prop-types";
import AskAiImg from "images/components/ai-tools/ask-ai-intro.gif";
import EpgImg from "images/components/ai-tools/epg-intro.gif";
import DqgImg from "images/components/ai-tools/dqg-intro.gif";
import QqgImg from "images/components/ai-tools/qqg-intro.gif";

import { useAccessTier } from "contexts/AccessTierContext";
import { AI_TOOL_NAMES } from "../../constants";

const InitialMessageExample = ({ locked, toolName, inContent }) => {
  const { isSignedOut, isFree } = useAccessTier();
  switch (toolName) {
    case AI_TOOL_NAMES.ASK_AI:
      if (isSignedOut) return null;
      if (isFree && inContent) return null;
      if (isFree) {
        return (
          <div className="body-2 notice">
            For best results, make your questions as specific as possible.
          </div>
        );
      }
      if (inContent) {
        return null;
      }

      if (locked) {
        return (
          <div className="body-2">
            <span>See Ask LitCharts AI in action below:</span>
            <img
              className="ask-litcharts-ai--gif"
              src={AskAiImg}
              alt="Ask LitCharts AI intro"
            />
          </div>
        );
      }

      return (
        <div className="body-2 notice">
          For best results, make your questions as specific as possible.
        </div>
      );
    case AI_TOOL_NAMES.DISCUSSION_QUESTIONS:
      if (inContent) return null;
      return locked ? (
        <div className="body-2">
          <span>See the Discussion Question Generator in action below:</span>
          <img
            className="ask-litcharts-ai--gif"
            src={DqgImg}
            alt="Ask LitCharts AI intro"
          />
        </div>
      ) : null;
    case AI_TOOL_NAMES.QUIZ_QUESTIONS:
      return locked ? (
        <div className="body-2">
          <span>See the Quiz Question Generator in action below:</span>
          <img
            className="ask-litcharts-ai--gif"
            src={QqgImg}
            alt="Ask LitCharts AI intro"
          />
        </div>
      ) : null;
    case AI_TOOL_NAMES.ESSAY_PROMPTS:
      return locked ? (
        <div className="body-2">
          <span>See the Essay Prompt Generator in action below:</span>
          <img
            className="ask-litcharts-ai--gif"
            src={EpgImg}
            alt="Ask LitCharts AI intro"
          />
        </div>
      ) : null;
    default:
      return null;
  }
};

InitialMessageExample.propTypes = {
  inContent: PropTypes.bool.isRequired,
  locked: PropTypes.bool.isRequired,
  toolName: PropTypes.oneOf(Object.values(AI_TOOL_NAMES)).isRequired
};

export default InitialMessageExample;
